<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="imaged"><img alt="Image" src="e9781534435742/images/f000v-01.jpg"/></p>
<p class="ded"><span aria-label="v" epub:type="pagebreak" id="page_v" role="doc-pagebreak" title="v">To Mom</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c13be75e